import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-calendar',
  templateUrl: './icon-calendar.component.html',
  styleUrls: ['./icon-calendar.component.scss']
})
export class IconCalendarComponent implements OnInit {
  @Input() theme: string;
  @Input() color: string;

  public colors: any = {
    earth: '#000000',
    minimal: '#FF0B4F',
    tiffany: '#4C5270',
    holidays: '#E43434',
    ocean: '#4C5270',
    purple: '#330033',
    'positive-impact': '#000000',
    empower: '#000000'
  };

  constructor() { }

  ngOnInit(): void {
  }

}
